import { locales } from "./locales";

export default function dateTimeFormat(UTCStr: string | Date, lang: string) {
	return new Intl.DateTimeFormat(locales[lang], {
		year: "numeric", month: "numeric", day: "numeric",
		hour: 'numeric', minute: 'numeric', second: 'numeric',
		timeZone: "Asia/Jakarta", timeZoneName: "short"
	}).format(new Date(UTCStr));
}
